import MultiLanguageInput from './MultiLanguageInput';

export default MultiLanguageInput;
